package com.cybergstudios.rtc.engine

import com.cybergstudios.rtc.world.Polygon

interface Context {
    fun clearCanvas()
    fun renderGameWin(state: GameState)
    fun renderGameLost(state: GameState)
    fun scheduleNextFrame(engine: Engine)
    fun getTick(): Double
    fun renderGrid(state: GameState) {
        state.grid.polygons.forEach {
            renderPolygon(it, state)
        }
    }
    fun renderPolygon(polygon: Polygon, state: GameState)
    fun renderPaddlePlayer(state: GameState)
    fun renderPaddleOpponent(state: GameState)
    fun renderBall(state: GameState)

    fun renderShipsMenu(playerLives: Int)
    fun renderPlayerScore(playerPoints: Int)
}
